import type { PropsWithChildren } from 'react'
import { horizontalGap, Icon, Popover, PopoverRoot, PopoverTrigger, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

const InfoButton = styled.button`
  margin-bottom: ${tk('spacing_xs')};
  color: ${tk('color_semantic_text_strong')};
  width: fit-content;
`

const Heading = styled(Typography)`
  margin-bottom: ${tk('spacing_md')};

  @media ${tk('mq_desktop_sm')} {
    margin-bottom: ${tk('spacing_xl')};
  }
`

const InfoButtonContent = styled.div`
  display: flex;
  align-items: center;

  ${horizontalGap('spacing_xs')}
`

export function ProductAdsComponent({
  headerTitle,
  infoContent,
  infoLabel,
  children,
}: PropsWithChildren<{
  infoLabel: string | null
  infoContent: string | null
  headerTitle: string | null
}>) {
  return (
    <>
      <PopoverRoot>
        {infoLabel && infoContent && (
          <PopoverTrigger asChild>
            <InfoButton>
              <InfoButtonContent>
                <Typography $variant="body-sm">{infoLabel}</Typography>
                <Icon glyph="IconInformationCircle" size="sm" />
              </InfoButtonContent>
            </InfoButton>
          </PopoverTrigger>
        )}
        {headerTitle && (
          <Heading $variant="heading-md" as="h2">
            {headerTitle}
          </Heading>
        )}
        {children}
        <Popover title={infoLabel ?? ''} content={infoContent ?? ''} align="start" avoidCollisions={false} side="top" />
      </PopoverRoot>
    </>
  )
}
